import { Comparable } from '../../../helpers/entities/comparable.interface';
import { Trackable } from '../../../helpers/entities/trackable.interface';
import { CreateUser } from './create-user.entity';
import { User } from './user.entity';

export class PaginatedUser extends User implements Comparable, Trackable {
    constructor(user: User) {
        super();

        this.Id = user.Id;
        this.Login = user.Login;
        this.FirstName = user.FirstName;
        this.LastName = user.LastName;
        this.IsSystem = user.IsSystem;
        this.Organisation = user.Organisation;
        this.Type = user.Type;
        this.Context = user.Context;
        this.Roles = user.Roles;
        this.LastLoginDate = user.LastLoginDate;
    }

    public static fromUser(user: User): PaginatedUser {
        return new PaginatedUser(user);
    }

    public getDetailUrl(): string {
        return `/user-management/users/${this.Id}`;
    }

    public getEditUrl(): string {
        return this.getDetailUrl() + '/edit';
    }

    equals(other: any): boolean {
        if (!(other instanceof CreateUser)) {
            return false;
        }
        return this.Id === other.Id;
    }

    trackBy(): string {
        return this.Id ?? '';
    }
}
